import { BANNER_COLORS } from '../../../banner/constants';
import { PipelineConfig } from '../../../shared/interfaces/integration';
import { SyncFrequencyTypeFeatureOption } from '../../interfaces/pipeline-settings-config';

export enum PipelineSettingsFormFields {
  PIPELINE_NAME = 'pipelineName',
  DESTINATION_PREFIX = 'destinationPrefix',
  DESTINATION_PARTITION_KEY = 'destinationPartitionKey',
  LOAD_MODE = 'loadMode',
  ERROR_MODE = 'errorMode',
  SYNC_TYPE = 'syncType',
  OBJECT_LEVEL_ERROR_MODE = 'objectLevelErrorMode',
  SCHEMA_EVOLUTION = 'schemaEvolution',
  SYNC_FREQUENCY = 'syncFrequency',
  SYNC_FREQUENCY_IN_CRON = 'syncFrequencyInCron',
  SYNC_FREQUENCY_TYPE = 'syncFrequencyType',
  DESTINATION_TABLE_SETTINGS = 'destinationTableSettings',
  REPLICATION_TYPE = 'replicationType',
  LATENCY_THRESHOLD_ALERT_ENABLED = 'latencyThresholdAlertEnabled',
  LATENCY_THRESHOLD = 'latencyThreshold'
}

export interface PipelineSettingsFormState {
  [PipelineSettingsFormFields.PIPELINE_NAME]: string;
  [PipelineSettingsFormFields.DESTINATION_PREFIX]: string;
  [PipelineSettingsFormFields.DESTINATION_PARTITION_KEY]: string;
  [PipelineSettingsFormFields.LOAD_MODE]: string;
  [PipelineSettingsFormFields.ERROR_MODE]: string;
  [PipelineSettingsFormFields.SYNC_TYPE]: string;

  [PipelineSettingsFormFields.OBJECT_LEVEL_ERROR_MODE]: string;
  [PipelineSettingsFormFields.SCHEMA_EVOLUTION]: string;
  [PipelineSettingsFormFields.SYNC_FREQUENCY]?: number;
  [PipelineSettingsFormFields.SYNC_FREQUENCY_IN_CRON]?: string;
  [PipelineSettingsFormFields.SYNC_FREQUENCY_TYPE]?: SyncFrequencyTypeFeatureOption;
  [PipelineSettingsFormFields.DESTINATION_TABLE_SETTINGS]: string;
  [PipelineSettingsFormFields.REPLICATION_TYPE]: string;
  [PipelineSettingsFormFields.LATENCY_THRESHOLD_ALERT_ENABLED]: boolean;
  [PipelineSettingsFormFields.LATENCY_THRESHOLD]?: number;
}

export interface PipelineSettingsAsyncFields {
  [PipelineSettingsFormFields.PIPELINE_NAME]: string;
  [PipelineSettingsFormFields.DESTINATION_PREFIX]: string;
  [PipelineSettingsFormFields.DESTINATION_PARTITION_KEY]: string;
}

export interface PipelineConfigPayload {
  name: string;
  destination_prefix: string;
  config: PipelineConfig;
}

export interface PipelineConfigModeOption<T = string | number> {
  id: string | number;
  value: T;
  label: string;
  description?: string;
  isRecommended?: boolean;
  isComingSoon?: boolean;
  banner?: {
    title: string;
    icon: string;
    description: string;
    color: (typeof BANNER_COLORS)[number];
  };
}
